import { render } from "./NextStep.vue?vue&type=template&id=28acf242"
import script from "./NextStep.vue?vue&type=script&lang=js"
export * from "./NextStep.vue?vue&type=script&lang=js"

import "./NextStep.vue?vue&type=style&index=0&id=28acf242&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__